import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Body1 } from '@ui/Typography'
import { Modal } from '@ui/components/Modal'

import { Box } from '@shared/components/Box'

export const TotalPortfolioModal: BaseModalType = (props) => {
  const { close } = props
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Wallet.Total Portfolio Value')}</Modal.Header>
      <Modal.Body>
        <Box flex align='center' gap='x8'>
          <Body1>{t('Wallet.Total Portfolio value description')}</Body1>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Primary onClick={close}>{t('Close')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
